"use client";
import CommonTitle from "../common/CommonTitle";
import CommonSubtitle from "../common/CommonSubtitle";
import adBgImage from "@/assets/images/advertisement/bg-ad-banner.svg";

const buttonItems = [
  "Goals/OKRs",
  "Portfolios",
  "Projects",
  "Tasks",
  "Docs",
  "Forms",
  "Chat",
  "Track Time",
  "Integrations",
  "Automations",
];

const renderButtonRow = (items: string[], startIndex: number = 0) => (
  <div className="flex w-full flex-wrap items-center justify-center gap-3 md:gap-4">
    {items.map((item, index) => (
      <button
        key={startIndex + index}
        className="rounded-lg border border-white/40 bg-[#3A3A60]/90 px-8 py-2 text-[16px] font-medium text-white backdrop-blur-sm transition-all duration-300 hover:border-white/60 hover:bg-[#3A3A60]"
      >
        {item}
      </button>
    ))}
  </div>
);

const EnterpriseCtaBox = () => {
  return (
    <div className="relative z-10 overflow-hidden">
      <div
        className="absolute left-0 top-0 -z-10 h-full w-full"
        style={{
          backgroundImage: `url(${adBgImage.src})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <section className="py-12 xlg:py-20">
        <div className="container">
          <div className="flex flex-col items-center gap-8 text-center">
            <div className="flex flex-col items-center gap-4">
              <CommonTitle
                fontSizeClass="text-[24px] lg:text-[32px]"
                fontWeightClass="font-bold"
                as="h2"
                color="#fff"
              >
                Kroolo Work AI for All
              </CommonTitle>
              <CommonSubtitle
                color="#fff"
                fontSizeWeight="text-[14px] font-normal xl:text-[16px]"
              >
                For everyone at work. Find, create & automate anything. Across
                all your data & apps.
              </CommonSubtitle>
            </div>
            <div className="flex w-full flex-col gap-4">
              {renderButtonRow(buttonItems.slice(0, 7), 0)}
              {renderButtonRow(buttonItems.slice(7), 7)}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EnterpriseCtaBox;
